import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';

export type Industry = IdValue;

export const getIndustries = createEndpoint<Industry[]>(({ fetch }) => () => fetch('/Configuration/GetIndustries'));